/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Mine from './Mine/index'
import No from './No/index'
import React from 'react'
import Theirs from './Theirs/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Internal/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let authAccessTokenDataUserIdValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.user_id',
})
let internalUserIdValueData = fromData.useDataValue({ viewPath,
context: 'internal',
path: 'user.id',
})
let aggregateData = fromHelpers.view(authAccessTokenDataUserIdValueData, internalUserIdValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Mine'}>
<Mine
  viewPath={`${viewPath}/Mine`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Theirs'}>
<Theirs
  viewPath={`${viewPath}/Theirs`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}